export enum WealthPortfolioTabsIndexes {
  Performance = 0,
  Allocation = 1,
  Orders = 2,
  About = 3
}
